import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import t from '@instructure/quiz-i18n/format-message';
import { toErrors } from '../../../util/instUIMessages';
import { simpleFetchBanks } from '../../../../banks/api/banks';
import { GenericAsyncSearch } from '../../shared/GenericAsyncSearch/GenericAsyncSearch';
export var BankSelection = /*#__PURE__*/function (_Component) {
  function BankSelection(props) {
    var _this2;
    _classCallCheck(this, BankSelection);
    _this2 = _callSuper(this, BankSelection, [props]);
    _defineProperty(_this2, "setInputRef", function (ref) {
      var _this2$props$inputRef, _this2$props;
      _this2.inputRef = ref;
      (_this2$props$inputRef = (_this2$props = _this2.props).inputRef) === null || _this2$props$inputRef === void 0 || _this2$props$inputRef.call(_this2$props, ref);
    });
    _defineProperty(_this2, "searchBanks", function (search) {
      return _this2.props.simpleFetchBanks({
        search: search
      }).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          banks = _ref2[0];
        return banks.map(function (b) {
          return _objectSpread(_objectSpread({}, b), {}, {
            text: b.title
          });
        });
      });
    });
    _defineProperty(_this2, "onSelect", function (e, bankOption) {
      return _this2.props.onBankSelection(e, _objectSpread(_objectSpread({}, bankOption), {}, {
        title: bankOption.text
      }));
    });
    _this2.inputRef = null;
    return _this2;
  }
  _inherits(BankSelection, _Component);
  return _createClass(BankSelection, [{
    key: "focusSelectField",
    value: function focusSelectField() {
      if (this.inputRef) {
        this.inputRef.focus();
      }
    }
  }, {
    key: "getErrors",
    value: function getErrors() {
      var selectedBank = this.props.selectedBank;
      if (selectedBank && selectedBank.archived) {
        this.focusSelectField();
        return toErrors([t('The item bank "{ bankTitle }" no longer exists. Please select a valid bank.', {
          bankTitle: selectedBank.title
        })]);
      }
      if (this.props.externalError) {
        this.focusSelectField();
        return this.props.externalError;
      }
    }
  }, {
    key: "selectedOption",
    value: function selectedOption() {
      var selectedBank = this.props.selectedBank;
      return selectedBank ? _objectSpread(_objectSpread({}, selectedBank), {}, {
        text: selectedBank.title
      }) : null;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(GenericAsyncSearch, {
        inputRef: this.setInputRef,
        onSelectionChange: this.onSelect,
        label: this.props.label || t('Select the destination bank'),
        placeholder: t('Search for a bank'),
        selectedOption: this.selectedOption(),
        getOptions: this.searchBanks,
        messages: this.getErrors(),
        selectAutomation: 'sdk-item-bank-modal',
        isRequired: this.props.isRequired
      });
    }
  }]);
}(Component);
_defineProperty(BankSelection, "propTypes", {
  label: PropTypes.string,
  onBankSelection: PropTypes.func,
  selectedBank: ImmutablePropTypes.record,
  simpleFetchBanks: PropTypes.func,
  externalError: ImmutablePropTypes.record,
  inputRef: PropTypes.func,
  isRequired: PropTypes.bool
});
_defineProperty(BankSelection, "defaultProps", {
  label: null,
  onBankSelection: function onBankSelection() {},
  selectedBank: null,
  simpleFetchBanks: simpleFetchBanks,
  externalError: null,
  inputRef: function inputRef() {},
  isRequired: false
});
export default BankSelection;